module.exports = __webpack_public_path__ + "century-gothic-bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/century-gothic-bold.ttf
// module id = 1576
// module chunks = 4